import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { Icon, Button } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
// import OrderImport from '../OrderImport';
import PopUpWrapper from '../PopUpWrapper';
import { connect } from '../../Store';
import { __ } from '../../Utils';
import OrderImport from '../OrderImport';

const Wrapper = styled.div`
  position: relative;
  background-color: #d2d2d2;
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
`;

const ScrollContainer = styled.div`
  overflow: auto;

  background-color: #d2d2d2;
`;

const OpenerButton = styled(Button)`
  padding: 0;
  border: 0;
  position: absolute;
  top: ${rem(5)};
  right: ${rem(8)};
  z-index: 10;
  display: block;
  &:hover,
  &:focus {
    background-color: transparent;
  }
  svg {
    transition: transform 0.3s ease;
  }
`;

const ListWrapper = styled.ul`
  margin: 0;
  padding: 0;
  /* overflow: auto; */
`;

const Text = styled.span`
  transition: ${({ isMenuOpen }) => (isMenuOpen ? 'opacity 1s ease' : 'none')};
  font-weight: 300;
  color: ${({ selected, theme }) =>
    selected ? theme.color.primary : '#2b2b2b'};
  /* display: none; */
  opacity: 0;
  &:hover {
    color: ${({ theme }) => theme.color.primary};
  }
  border-left: 4px solid
    ${({ theme, isSubOpened }) =>
      isSubOpened ? theme.color.primary : 'transparent'};
  padding-left: ${rem(8)};
`;

const SectionIcon = styled(Icon)`
  position: absolute;
  left: ${rem(-10)};
  top: 50%;
  svg path {
    transition: fill 0.3s ease;
  }
`;

const ElapseIcon = styled(Icon)`
  transition: ${({ isMenuOpen }) =>
    isMenuOpen ? 'opacity 0.9s ease' : 'none'};
  font-weight: 300;
  color: #2b2b2b;
  opacity: 0;
`;

const ElapseIconWrapper = styled.div`
  height: 100%;
  width: ${rem(48)};
  padding-top: ${rem(3)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ActionLink = styled(Link)`
text-decoration: none;
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.color.textColor};
  height: ${rem(40)};
  position: relative;
padding-left: ${props => (props.menuOpen ? rem(50) : 0)};
  transition: background-color 0.3s ease;
  line-height: ${({ theme }) => theme.font.lineHeight};
  /* &:hover {
    color: ${({ theme }) => theme.color.primary};
  } */
  ${({ showBorder, theme }) =>
    showBorder
      ? css`
          border-left: 4px solid ${theme.color.primary};
          */background-color: ${theme.color.primaryBg};
          */ ${SectionIcon} {
            svg path {
              fill: ${theme.color.primary};
            }
          }
        `
      : css`
          background-color: transparent;
        `};
`;

const List = styled.li`
  list-style-type: none;
  min-height: ${rem(40)};
`;

const SubListWrapper = styled(ListWrapper)`
  font-size: ${({ theme }) => theme.font.fontSizeXS};
  margin: ${rem(5)} 0 ${rem(8)};
  ${List} {
    border-bottom: 0;
    margin-bottom: ${rem(5)};
    min-height: inherit;
  }
  ${ActionLink} {
    height: auto;
    padding-left: ${rem(50)};
    color: ${({ theme }) => theme.mainMenu.submenuTextColor};
    &:hover {
      background-color: transparent;
      color: ${({ theme }) => theme.color.primary};
    }
  }
`;

const Overlay = styled.aside`
  width: ${({ menuOpen }) => (menuOpen ? `${rem(250)}` : `${rem(55)}`)};
  transition: width 0.3s ease;
  /* overflow: auto; */
  background-color: #d2d2d2;
  height: ${({ height }) => height || '100%'};
  position: relative;
  z-index: 5;
  padding-bottom: ${rem(300)};
  /* border-right: ${rem(2)} solid ${({ theme }) =>
  theme.mainMenu.borderColor}; */
  ${({ menuOpen }) =>
    menuOpen
      ? css`
          ${OpenerButton} {
            svg {
              transform: rotate(180deg);
            }
          }
          ${ActionLink} {
            &:hover {
              ${SectionIcon} {
                svg path {
                  fill: ${({ theme }) => theme.color.primary};
                }
              }
            }
          }
          ${SectionIcon} {
            left: ${rem(20)};
            transform: translate(0, -50%);
          }
          ${Text} {
            /* display: block; */
            transition: ${({ isMenuOpen }) =>
              !isMenuOpen ? 'opacity 1s ease' : 'none'};
            opacity: 1;
            text-align: start;
          }
          ${ElapseIcon} {
            display: block;
            transition: ${({ isMenuOpen }) =>
              !isMenuOpen ? 'opacity 0.9s ease' : 'none'};
            opacity: 1;
          }
        `
      : css`
          ${OpenerButton} {
            svg {
              transform: rotate(360deg);
            }
          }
          ${ActionLink} {
            &:hover {
              svg path {
                fill: ${({ theme }) => theme.color.danger};
              }
            }
          }
          ${SectionIcon} {
            left: 50%;
            transform: translate(-50%, -50%);
          }
        `};
`;

const MenuOpenWrapper = styled(ActionLink)`
  /* right: -190px; */
  background: #b5b3b3;
  ${SectionIcon} {
    right: 10px;
    display: flex;
    justify-content: flex-end;
  }
`;

class SidebarMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      activeSectionIds: [],
    };
  }

  componentDidMount() {
    const { activeSectionIdsSaved, menuState } = this.props;
    if (menuState === false || menuState === true) {
      const activeSectionIds = activeSectionIdsSaved || [];

      this.setState({
        menuOpen: menuState,
        activeSectionIds,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.menuOpen !== nextProps.menuState) {
      this.props.onMenuOpen(nextProps.menuState);
      this.setState({
        menuOpen: nextProps.menuState,
      });
    }

    if (this.props.activeMenuItem !== nextProps.activeMenuItem) {
      this.setState({
        activeSubMenuId: nextProps.activeMenuItem,
      });
    }
  }

  handleToggleMenu = () => {
    this.setState(prevState => ({ menuOpen: !prevState.menuOpen }));
    this.props.onMenuOpen(!this.state.menuOpen);
  };

  handleOpenSubMenu = (section, level) => {
    const { menuOpen } = this.state;
    const { sections } = this.props;
    let { activeSubMenuId, activeSectionIds } = this.state;

    if (level === 1) {
      const urlSection = this.props.children
        ? this.props.children.filter(s => s.url).map(u => u._id)
        : [];

      activeSectionIds = activeSectionIds.filter(
        a => urlSection.indexOf(a) === -1,
      );

      if (activeSectionIds.find(a => a === section._id) && menuOpen) {
        activeSectionIds.splice(activeSectionIds.indexOf(section._id), 1);
      } else {
        activeSectionIds.push(section._id);
      }

      this.setState({
        activeSectionIds,
        menuOpen: true,
      });
    } else {
      activeSubMenuId = section._id;

      activeSectionIds = activeSectionIds.filter(
        a =>
          sections.find(s => s._id === a) &&
          sections.find(s => s._id === a).children,
      );

      this.setState({
        activeSubMenuId,
        activeSectionIds,
      });
    }

    this.handleOnClickLink(section, activeSectionIds, activeSubMenuId);
    if (!menuOpen) {
      this.props.onMenuOpen(!this.state.menuOpen);
    }
  };

  handleOnClickLink(item, activeSectionIds) {
    localStorage.setItem('activeSectionIds', JSON.stringify(activeSectionIds));

    if (item.url) {
      this.props.history.push(item.url);
    }

    if (item.popup === 'import') {
      this.setState({
        showImport: true,
      });
    }
  }

  itemRenderer = (section, idx, level) => {
    const { activeSectionIds, activeSubMenuId, menuOpen } = this.state;

    return (
      <List key={section._id}>
        <ActionLink
          to={section.url}
          onClick={() => {
            if (!section.url) this.handleOpenSubMenu(section, level);
          }}
          showBorder={
            level === 1 &&
            activeSectionIds.indexOf(section._id) > -1 &&
            section.url
          }
          menuOpen={menuOpen}
        >
          {level === 1 && section.icon && (
            <SectionIcon
              size="m"
              name={section.icon}
              onClick={this.handleOpenMenu}
            />
          )}
          {menuOpen && (
            <Text
              style={{
                marginBottom: level > 1 && rem(4),
              }}
              isMenuOpen={this.state.menuOpen}
              isSubOpened={
                level > 1 &&
                !section.children &&
                activeSubMenuId === section._id
              }
            >
              {__(section.name)}
            </Text>
          )}
          {section.children && (
            <ElapseIconWrapper
              onClick={() => {
                this.handleOpenSubMenu(section, level);
              }}
            >
              <ElapseIcon
                isMenuOpen={this.state.menuOpen}
                name={
                  activeSectionIds.indexOf(section._id) > -1
                    ? 'expand_less'
                    : 'expand_more'
                }
                color="#2b2b2b"
                size="l"
              />
            </ElapseIconWrapper>
          )}
        </ActionLink>
        {(activeSectionIds.indexOf(section._id) > -1 ||
          (section.children &&
            section.children.find(
              s => activeSectionIds.indexOf(s._id) > -1,
            ))) &&
          menuOpen && (
            <SubListWrapper>
              {section.children &&
                section.children.map(item =>
                  this.itemRenderer(item, idx, level + 1),
                )}
            </SubListWrapper>
          )}
      </List>
    );
  };

  render() {
    const { sections } = this.props;
    const { showImport } = this.state;

    return (
      <Wrapper>
        <PopUpWrapper
          display={showImport}
          alignUnderHeader
          message={__('Import objednávky')}
          customWidth={600}
          onClose={() =>
            this.setState({
              showImport: false,
            })
          }
        >
          <OrderImport
            toCart={() =>
              this.setState(
                {
                  showImport: false,
                },
                () => this.props.history.push('/shopping-cart?step=1'),
              )
            }
          />
        </PopUpWrapper>

        <ScrollContainer
          style={{
            minHeight: this.props.height,
          }}
        >
          <Overlay menuOpen={this.state.menuOpen} height={this.props.height}>
            <MenuOpenWrapper onClick={this.handleToggleMenu}>
              <SectionIcon
                size="xl"
                name={this.state.menuOpen ? 'menu_close1' : 'dehaze'}
                onClick={this.handleToggleMenu}
              />
            </MenuOpenWrapper>

            <ListWrapper>
              {sections.map((item, idx) => this.itemRenderer(item, idx, 1))}
            </ListWrapper>
          </Overlay>
        </ScrollContainer>
      </Wrapper>
    );
  }
}

SidebarMenu.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      name: PropTypes.string,
      id: PropTypes.string,
      url: PropTypes.string,
    }).isRequired,
  ).isRequired,
  onMenuOpen: PropTypes.func.isRequired,
  menuState: PropTypes.bool,
  height: PropTypes.string,
  // setActiveIdTo: PropTypes.string,
  role: PropTypes.string,
  activeSectionIdsSaved: PropTypes.arrayOf(PropTypes.string),
};

SidebarMenu.defaultProps = {
  menuState: null,
  height: null,
  // setActiveIdTo: null,
  activeSectionIdsSaved: [],
  role: '',
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(withRouter(SidebarMenu));



// WEBPACK FOOTER //
// ./src/Components/SideBarMenu/index.jsx